<div class="pin-dialog">
  <div class="pin-head">
    <div class="pin-title">{{ data.title || 'PIN DE SEGURIDAD' }}</div>
    <div class="pin-desc">{{ data.message }}</div>
  </div>

  <div class="pin-body">
    <div class="pin-otp">
      <div class="pin-otp-label">PIN (6 DÍGITOS)</div>

      <div class="pin-otp-grid">
        <input
          #pinDigit
          *ngFor="let _ of pinDigits; let i = index"
          class="pin-otp-input"
          type="text"
          maxlength="1"
          inputmode="numeric"
          autocomplete="off"
          autocapitalize="off"
          spellcheck="false"
          [attr.name]="'rmd-pin-' + i"
          [value]="pinOtp[i]"
          (input)="onOtpInput($event, i)"
          (keydown)="onOtpKeyDown($event, i)"
          (paste)="onOtpPaste($event)"
        />
      </div>

      <!-- ✅ Estado: validando / ok / error -->
      <div class="pin-remote-status" *ngIf="pinRemoteStatus !== 'idle'">
        <ng-container [ngSwitch]="pinRemoteStatus">
          <div *ngSwitchCase="'checking'" class="status checking">
            VALIDANDO PIN...
          </div>

          <div *ngSwitchCase="'valid'" class="status valid">
            ✅ PIN CORRECTO
          </div>

          <div *ngSwitchCase="'invalid'" class="status invalid">
            ❌ PIN INCORRECTO
          </div>
        </ng-container>
      </div>

      <div class="pin-otp-error" *ngIf="errorMsg">{{ errorMsg }}</div>

      <div class="pin-tools">
        <button mat-stroked-button type="button" (click)="clear()">
          LIMPIAR
        </button>
      </div>
    </div>
  </div>

  <div class="pin-actions">
    <button
      mat-stroked-button
      type="button"
      (click)="continueWithoutPin()"
      *ngIf="data?.optional !== false">
      CONTINUAR SIN PIN
    </button>

    <button
      mat-flat-button
      color="primary"
      type="button"
      (click)="confirm()"
      [disabled]="!canConfirm">
      CONFIRMAR
    </button>
  </div>
</div>
